import { SurveyFragment } from '@occc/graphql';
import { awardHelper } from '@occc-app/offerHelpers/utils/awardHelper';
import { AwardType } from '@occc-app/offerHelpers/types';
import { LinkItem } from '@occc/ui-design-system';

import { routeCreator } from '../utils';
import { IncentivizeResponsesFormValues } from '../types';

export const getIncentivizeResponsesInitialValues = (
  award?: SurveyFragment['award'],
): IncentivizeResponsesFormValues => {
  if (award) {
    return {
      isEnabled: true,
      awardType: awardHelper.isPointsAward(award) ? AwardType.AwardPoints : AwardType.AwardVouchers,
      awardPoints: awardHelper.isPointsAward(award) ? award : undefined,
      awardVouchers: awardHelper.isSurveyVouchersAward(award) ? award : undefined,
    };
  }

  return {
    isEnabled: false,
    awardType: AwardType.AwardPoints,
    awardPoints: undefined,
    awardVouchers: undefined,
  };
};

export const getBreadcrumbLinks = (pageLabel: string): LinkItem[] => [
  { to: routeCreator.list(), label: 'Wallets' },
  { key: routeCreator.update(':id'), label: pageLabel },
];
